var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button no-tap-highlight",on:{"click":_vm.click}},[_c('span',{staticClass:"label"},[_vm._v(" "),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }